import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import Grid2 from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";

type Props = {};

export const TypesFilter = ({}: Props) => {
	const {
		state: { typeCodes },
	} = useAssetDetailsContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const type = searchParams.get("type") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("type", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box
			sx={{
				"& .MuiSelect-select": {
					backgroundColor: "#FFF",
					paddingTop: "6px",
					paddingBottom: "6px",
				},
			}}
		>
			<FormControl variant="outlined" size="small" sx={{ width: "100%" }}>
				<InputLabel id="types-select-label">Types</InputLabel>
				<Select
					labelId="types-select-label"
					id="types-select"
					value={type}
					onChange={handleFilter}
					label="Types"
				>
					{typeCodes.map((type) => {
						return (
							<MenuItem key={`logId-${type.id}`} value={type.id}>
								<Grid2 container alignItems="center">
									{type.description}
								</Grid2>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
